import { Box } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseRadioGroup, {
    BaseRadioGroupWithImage,
} from 'common/components/base-radio-group';
import { colors } from 'common/constants';
import React from 'react';
interface Props {
    name: string;
    options: {
        label: string;
        value: string;
        image?: string;
        type: number;
    }[];
}
const QuestionSingleShoice: React.FC<Props> = ({ name, options }) => {
    return (
        <Box>
            {options.some((option) => option.image) ? (
                <BaseRadioGroupWithImage
                    name={name}
                    options={options}
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: [
                                '0.7rem',
                                '1rem',
                                '1rem',
                                '1.6rem',
                                '1.8rem',
                            ],
                        },
                    }}
                    sxRadio={{
                        '& .MuiSvgIcon-root': { fontSize: 28 },
                        '& .MuiFormControlLabel-label': {
                            color: [common.white, common.black],
                            fontWeight: '500',
                        },
                        '&.Mui-checked + .MuiFormControlLabel-label': {
                            color: colors.main,
                            fontWeight: '500',
                        },
                    }}
                />
            ) : (
                <BaseRadioGroup
                    name={name}
                    options={options}
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: [
                                '0.9rem',
                                '1rem',
                                '1rem',
                                '1.6rem',
                                '1.8rem',
                            ],
                        },
                        '& .MuiFormControlLabel-root': {
                            marginLeft: [0, '-11px'],
                            marginRight: [0, '16px'],
                            marginBottom: ['16px', 'unset'],
                            width: ['100%', 'unset'],
                        },
                    }}
                    sxRadio={{
                        '& .MuiButtonBase-root': {
                            display: ['none', 'inline-flex'],
                            fontSize: [24, 24, 24, 24, 32],
                        },
                        '& .MuiFormControlLabel-label': {
                            color: common.black,
                            fontWeight: '500',
                            cursor: 'pointer',
                            backgroundColor: ['#fff', 'unset'],
                            width: '100%',
                            padding: ['1rem', 0],
                            borderRadius: '50px',
                        },
                        '&.Mui-checked + .MuiFormControlLabel-label': {
                            color: ['#fff', colors.main],
                            backgroundColor: [colors.main, 'unset'],
                            fontWeight: '500',
                        },
                    }}
                />
            )}
        </Box>
    );
};

export default QuestionSingleShoice;
